import { Component } from '@angular/core';
import { ChatService } from 'angular-lib';

@Component({
    selector: 'ez-chat-unread-bubble',
    template: require('./chat-unread-bubble.component.html'),
    styles: [require('./chat-unread-bubble.component.less')]
})

export class ChatUnreadBubbleComponent {

    constructor(
        private chatService: ChatService
    ) {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/chat-unread-bubble/chat-unread-bubble.component.ts